import { Box, Typography } from "@mui/material";
import Lottie from "lottie-react";
import React from "react";
import constructionAnimation from "../lotties/construction.json";

const Construction = () => {
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Box
        sx={{
          height: 400,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Lottie
          style={{ width: 400, height: 400 }}
          animationData={constructionAnimation}
          loop={false}
        />
      </Box>
      <Typography
        sx={{ textAlign: "center", mt: 2 }}
        variant="h3"
        component="h2"
        gutterBottom
      >
        Página en construcción
      </Typography>
    </Box>
  );
};

export default Construction;
